type ZoneEditionError = {
  isNameInvalid: boolean;
  hasDuplicateName: boolean;
  hasUnexpectedError: boolean;
  message: string;
};

const zoneEditionError: ZoneEditionError = {
  isNameInvalid: false,
  hasDuplicateName: false,
  hasUnexpectedError: false,
  message: "",
};

export type { ZoneEditionError };

export { zoneEditionError };
